import { Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
    textAlign: 'center',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
  glow: {
    textShadow: '0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12',
  },
}));

export default function Agency__Copy3(props) {
  const classes = useStyles();

  const [marginsA, setmarginsA] = useState(0);

  useEffect(() => {
    const Copy3aElement = document.getElementById('Copy3A');
    const calculatedMarginA = (window.innerHeight - Copy3aElement.clientHeight) / 2;
    setmarginsA(
      calculatedMarginA > window.innerHeight / 4 ? calculatedMarginA : window.innerHeight / 4,
    );
  }, []);

  return (
    <Container>
      <div id="Copy3A" style={{ margin: `${marginsA}px auto` }}>
        <Typography className={classes.textMonarcha} sx={{ color: '#fff' }} variant="h3">
          Your <span style={{ color: '#ffbf12' }}>creator agency</span>
          <br />
          Becomes <span style={{ color: '#ffbf12' }}>a startup company </span>
          <br />
          <br />
          - with stocks holding <br />
          and growing its value over time
          <br />
          <br />
          <span style={{ color: '#ffbf12' }}>
            To secure your <br />
            financial future.
          </span>
        </Typography>
      </div>
    </Container>
  );
}
